var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 13.3337C6.51095 13.3337 5.24984 12.817 4.2165 11.7837C3.18317 10.7503 2.6665 9.48921 2.6665 8.00033C2.6665 6.51144 3.18317 5.25033 4.2165 4.21699C5.24984 3.18366 6.51095 2.66699 7.99984 2.66699C8.7665 2.66699 9.49984 2.82533 10.1998 3.14199C10.8998 3.45866 11.4998 3.91144 11.9998 4.50033V2.66699H13.3332V7.33366H8.6665V6.00033H11.4665C11.1109 5.3781 10.6248 4.88921 10.0082 4.53366C9.3915 4.1781 8.72206 4.00033 7.99984 4.00033C6.88873 4.00033 5.94428 4.38921 5.1665 5.16699C4.38873 5.94477 3.99984 6.88921 3.99984 8.00033C3.99984 9.11144 4.38873 10.0559 5.1665 10.8337C5.94428 11.6114 6.88873 12.0003 7.99984 12.0003C8.85539 12.0003 9.62761 11.7559 10.3165 11.267C11.0054 10.7781 11.4887 10.1337 11.7665 9.33366H13.1665C12.8554 10.5114 12.2221 11.4725 11.2665 12.217C10.3109 12.9614 9.22206 13.3337 7.99984 13.3337Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.d75814266b5ce428d01994078671f3bf.svg";
export { ForwardRef as ReactComponent };